export const events = {
  experimentActivated: defaultExperimentActivatedHandler,
  experimentVariationViewed: defaultExperimentVariationViewedHandler,
};

export const onExperimentActivated = (handleEvent) => {
  events.experimentActivated = handleEvent;
};

export const onExperimentVariationViewed = (handleEvent) => {
  events.experimentVariationViewed = handleEvent;
};

function defaultExperimentActivatedHandler(experiment, variation) {
  /* eslint-disable-next-line no-console */
  console.info(`[Optimizely] Experiment activated`, experiment, variation);
}

function defaultExperimentVariationViewedHandler(experiment, variation) {
  /* eslint-disable-next-line no-console */
  console.info(
    `[Optimizely] Experiment variation viewed`,
    experiment,
    variation
  );
}
